export default (field) => {
  let label = field.closest('.Form__input-item')?.querySelector('.Form__label');
  if (!label) {
    label = field.querySelector('.Form__label');
  }

  if (label) {
    label.classList.add('Form__label--error');
  }
};
